










import { Component } from "vue-property-decorator";
import Header from "@/components/header/OLoginHeader.vue";
import CategoryList from "@/components/material/Categories.vue";
import Footer from "@/components/Footer.vue";
import CheckOrganizationAdminLogin from "@/utils/CheckOrganizationAdminLogin";

@Component({
  components: {
    Header,
    CategoryList,
    Footer,
  },
})
export default class OCategory extends CheckOrganizationAdminLogin {}
